<template>
  <div class="rank">
    <h4 class="title" :title="title">{{ title }}</h4>
    <ul v-if="list && list.length > 0" class="list">
      <li :key="index" v-for="(item, index) in list">
        <span :class="index < 3 ? 'active' : null">{{ index + 1 }}</span>
        <span class="label" :title="item[props.label]">{{ item[props.label] }}</span>
        <span class="value" :title="item[props.value]">{{ item[props.value] }}</span>
      </li>
    </ul>
    <div v-else class="list-empty">
      <img :src="emptyIcon" alt="暂无数据">
      <span>暂无数据</span>
    </div>
  </div>
</template>
<script>
// import emptyIcon from "@/assets/images/dashboard/icon/empty.png"
export default {
  name: 'VRankList',
  props: {
    title: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: null
    },
    props: {
      type: Object,
      default() {
        return {
          label: 'label',
          value: 'value'
        }
      }
    }
  },
  data () {
    return {
      emptyIcon
    }
  }
}
</script>

<style lang="less" scoped>
@text:rgba(0,0,0,.45);
  .rank {
    .title {
        font-size: 16px;
        overflow: hidden;
        white-space:nowrap;
        text-overflow:ellipsis;
    }
    .list {
      margin: 25px 0 0;
      padding: 0;
      list-style: none;
      li {
        margin-top: 16px;
        display: flex;
        justify-items: center;
        span {
          color: rgba(0, 0, 0, .65);
          font-size: 14px;
          &:first-child {
            background-color: #f5f5f5;
            border-radius: 20px;
            display: inline-block;
            font-size: 12px;
            font-weight: 600;
            margin-right: 16px;
            height: 20px;
            line-height: 20px;
            width: 20px;
            text-align: center;
          }
          &.active {
            background-color: #314659;
            color: #fff;
          }
          &.label {
            width: 50%;
            overflow: hidden;
            white-space:nowrap;
            text-overflow:ellipsis;
          }
          &.value {
            width: 30%;
            overflow: hidden;
            white-space:nowrap;
            text-overflow:ellipsis;
            text-align: right;
          }
        }
      }
    }
    .list-empty {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      color: @text;
      img {
        width: 70%;
        height: 70%;
        max-width: 284px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/charts/rank-list.vue